import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setCompanyIndustryType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const CompanyIndustryTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Industry"
      id="company_industry_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setCompanyIndustryType(option.id))
      }}
    />
  )
}
export default CompanyIndustryTypeDropdown
